export const GET_PROFILE_DETAILS = "ALLOCATOR@GET_PROFILE_DETAILS";
export const GET_PROFILE_DETAILS_INIT = "ALLOCATOR@GET_PROFILE_DETAILS_INIT";
export const GET_PROFILE_DETAILS_SUCCESS = "ALLOCATOR@GET_PROFILE_DETAILS_SUCCESS";
export const GET_PROFILE_DETAILS_FAILED = "ALLOCATOR@GET_PROFILE_DETAILS_FAILED";

export const GET_ALLOCATOR_Strategy = "ALLOCATOR@GET_ALLOCATOR_Strategy";
export const GET_ALLOCATOR_Strategy_INIT = "ALLOCATOR@GET_ALLOCATOR_Strategy_INIT";
export const GET_ALLOCATOR_Strategy_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_Strategy_SUCCESS";
export const GET_ALLOCATOR_Strategy_FAILED = "ALLOCATOR@GET_ALLOCATOR_Strategy_FAILED";

export const GET_STRATEGY = 'ALLOCATOR@GET_STRATEGY';
export const GET_STRATEGY_INIT = 'ALLOCATOR@GET_STRATEGY_INIT';
export const GET_STRATEGY_SUCCESS = 'ALLOCATOR@GET_STRATEGY_SUCCESS';
export const GET_STRATEGY_FAILED = 'ALLOCATOR@GET_STRATEGY_FAILED';

export const GET_ALL_INVESTOR = 'ALLOCATOR@GET_ALL_INVESTOR';
export const GET_ALL_INVESTOR_INIT = 'ALLOCATOR@GET_ALL_INVESTOR_INIT';
export const GET_ALL_INVESTOR_SUCCESS = 'ALLOCATOR@GET_ALL_INVESTOR_SUCCESS';
export const GET_ALL_INVESTOR_FAILED = 'ALLOCATOR@GET_ALL_INVESTOR_FAILED';

export const GET_COMPANY_POST_FEED = 'ALLOCATOR@GET_COMPANY_POST_FEED';
export const GET_COMPANY_POST_FEED_INIT = 'ALLOCATOR@GET_COMPANY_POST_FEED_INIT';
export const GET_COMPANY_POST_FEED_SUCCESS = 'ALLOCATOR@GET_COMPANY_POST_FEED_SUCCESS';
export const GET_COMPANY_POST_FEED_FAILED = 'ALLOCATOR@GET_COMPANY_POST_FEED_FAILED';

export const GET_COMPANY_USERS = 'ALLOCATOR@GET_COMPANY_USERS';
export const GET_COMPANY_USERS_INIT = 'ALLOCATOR@GET_COMPANY_USERS_INIT';
export const GET_COMPANY_USERS_SUCCESS = 'ALLOCATOR@GET_COMPANY_USERS_SUCCESS';
export const GET_COMPANY_USERS_FAILED = 'ALLOCATOR@GET_COMPANY_USERS_FAILED';

export const CREATE_ALLOCATOR_NETWORKS = "PROFILE@CREATE_ALLOCATOR_NETWORKS";
export const CREATE_ALLOCATOR_NETWORKS_INIT = "PROFILE@CREATE_ALLOCATOR_NETWORKS_INIT";
export const CREATE_ALLOCATOR_NETWORKS_SUCCESS = "PROFILE@CREATE_ALLOCATOR_NETWORKS_SUCCESS";
export const CREATE_ALLOCATOR_NETWORKS_FAILED = "PROFILE@CREATE_ALLOCATOR_NETWORKS_FAILED";

export const UPDATE_ALLOCATOR_NETWORKS = "PROFILE@UPDATE_ALLOCATOR_NETWORKS";
export const UPDATE_ALLOCATOR_NETWORKS_INIT = "PROFILE@UPDATE_ALLOCATOR_NETWORKS_INIT";
export const UPDATE_ALLOCATOR_NETWORKS_SUCCESS = "PROFILE@UPDATE_ALLOCATOR_NETWORKS_SUCCESS";
export const UPDATE_ALLOCATOR_NETWORKS_FAILED = "PROFILE@UPDATE_ALLOCATOR_NETWORKS_FAILED";

export const DELETE_ALLOCATOR_NETWORKS = "PROFILE@DELETE_ALLOCATOR_NETWORKS";
export const DELETE_ALLOCATOR_NETWORKS_INIT = "PROFILE@DELETE_ALLOCATOR_NETWORKS_INIT";
export const DELETE_ALLOCATOR_NETWORKS_SUCCESS = "PROFILE@DELETE_ALLOCATOR_NETWORKS_SUCCESS";
export const DELETE_ALLOCATOR_NETWORKS_FAILED = "PROFILE@DELETE_ALLOCATOR_NETWORKS_FAILED";

